(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["shipping-returns"] && !Shopify.designMode) return;
  try {
    (function(){
    'use strict';

    var SHIP_TIMEZONE   = 'Asia/Tokyo';
    var SHIP_UTC_OFFSET = 9;

    var REGION_TIMEZONES = {
      europe:    'Europe/London',
      usa:       'America/New_York',
      australia: 'Australia/Sydney',
      asia:      'Asia/Singapore',
      uae:       'Asia/Dubai'
    };

    function parseHolidays(raw){
      if (!raw) return [];
      return raw.split(',')
        .map(function(s){ return s.trim(); })
        .filter(function(s){ return /^\d{4}-\d{2}-\d{2}$/.test(s); });
    }

    function getJSTNow(){
      var f = new Intl.DateTimeFormat('en-CA', {
        timeZone: SHIP_TIMEZONE,
        year:'numeric', month:'2-digit', day:'2-digit',
        hour:'2-digit', minute:'2-digit', second:'2-digit',
        hour12:false
      });
      var o = {};
      f.formatToParts(new Date()).forEach(function(p){ o[p.type] = p.value; });
      var h = parseInt(o.hour, 10); if (h === 24) h = 0;
      return {
        date: o.year + '-' + o.month + '-' + o.day,
        year:  parseInt(o.year, 10),
        month: parseInt(o.month, 10),
        day:   parseInt(o.day, 10),
        hour: h,
        minute: parseInt(o.minute, 10),
        second: parseInt(o.second, 10)
      };
    }

    function getDayOfWeekOfISO(s){
      var p = s.split('-');
      return new Date(Date.UTC(+p[0], +p[1]-1, +p[2])).getUTCDay();
    }

    function isBusinessDay(s, holidays){
      var d = getDayOfWeekOfISO(s);
      if (d === 0 || d === 6) return false;
      if (holidays.indexOf(s) !== -1) return false;
      return true;
    }

    function addDaysToISO(s, days){
      var p = s.split('-');
      var t = new Date(Date.UTC(+p[0], +p[1]-1, +p[2]));
      t.setUTCDate(t.getUTCDate() + days);
      return t.getUTCFullYear() + '-' +
             String(t.getUTCMonth()+1).padStart(2,'0') + '-' +
             String(t.getUTCDate()).padStart(2,'0');
    }

    function dispatchMomentUTC(isoDate, cutoffHour){
      var p = isoDate.split('-');
      return new Date(Date.UTC(+p[0], +p[1]-1, +p[2], cutoffHour - SHIP_UTC_OFFSET, 0, 0));
    }

    function calculateShipDate(cutoffHour, holidays){
      var jst = getJSTNow();
      if (isBusinessDay(jst.date, holidays) && jst.hour < cutoffHour) return jst.date;
      var ds = jst.date;
      do { ds = addDaysToISO(ds, 1); } while (!isBusinessDay(ds, holidays));
      return ds;
    }

    function formatShipDate(isoDate){
      var p = isoDate.split('-');
      var dt = new Date(Date.UTC(+p[0], +p[1]-1, +p[2], 12, 0, 0));
      return new Intl.DateTimeFormat('en-US', {
        timeZone: SHIP_TIMEZONE, weekday:'long', month:'short', day:'numeric', year:'numeric'
      }).format(dt);
    }

    function formatArrival(utcMoment, tz){
      return new Intl.DateTimeFormat('en-US', {
        timeZone: tz, weekday:'long', month:'short', day:'numeric'
      }).format(utcMoment);
    }

    function formatCountdown(ms){
      if (ms < 0) ms = 0;
      var totalMin = Math.floor(ms / 60000);
      var hours = Math.floor(totalMin / 60);
      var mins  = totalMin % 60;
      if (hours > 0){
        return hours + (hours === 1 ? ' Hour ' : ' Hours ') +
               mins  + (mins  === 1 ? ' min'  : ' mins');
      }
      return mins + (mins === 1 ? ' min' : ' mins');
    }

    function formatJapanTime(jst){
      var hh = String(jst.hour).padStart(2,'0');
      var mm = String(jst.minute).padStart(2,'0');
      return jst.year + '/' + jst.month + '/' + jst.day + ' ' + hh + ':' + mm;
    }

    function updateJapanTime(root){
      var el = root.querySelector('[data-japan-time-value]');
      if (!el) return;
      el.textContent = formatJapanTime(getJSTNow());
    }

    function updateAll(root){
      var cutoffHour = parseInt(root.getAttribute('data-cutoff-hour'), 10) || 10;
      var holidays   = parseHolidays(root.getAttribute('data-holidays') || '');
      var shipDate   = calculateShipDate(cutoffHour, holidays);
      var baseUTC    = dispatchMomentUTC(shipDate, cutoffHour);
      var nowMs      = new Date().getTime();
      var cutoffMs   = baseUTC.getTime();

      var cdEl = root.querySelector('[data-shipping-countdown]');
      if (cdEl) cdEl.textContent = formatCountdown(cutoffMs - nowMs);

      var shipEl = root.querySelector('[data-ship-date]');
      if (shipEl) shipEl.textContent = formatShipDate(shipDate);

      Object.keys(REGION_TIMEZONES).forEach(function(key){
        var el = root.querySelector('[data-region="' + key + '"]');
        if (!el) return;
        var transit = parseInt(root.getAttribute('data-transit-' + key), 10);
        if (isNaN(transit)) transit = 2;
        var arrival = new Date(baseUTC.getTime() + transit * 86400000);
        el.textContent = formatArrival(arrival, REGION_TIMEZONES[key]);
      });

      updateJapanTime(root);
    }

    function setupToggle(root){
      if (root.getAttribute('data-enable-accordion') !== 'true') return;
      var btn  = root.querySelector('[data-toggle-shipping]');
      var body = root.querySelector('.shipping-returns__body');
      if (!btn || !body) return;
      btn.addEventListener('click', function(){
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (expanded){
          body.setAttribute('hidden', '');
        } else {
          body.removeAttribute('hidden');
        }
      });
    }

    function tickJapanTime(){
      document.querySelectorAll('[data-shipping-returns]').forEach(function(root){
        try { updateJapanTime(root); } catch (e) {}
      });
    }

    function init(){
      document.querySelectorAll('[data-shipping-returns]').forEach(function(root){
        if (root.__shippingInit) return;
        root.__shippingInit = true;
        setupToggle(root);
        try { updateAll(root); } catch (e) {}
      });

      // Refresh delivery numbers every 30 seconds (countdown precision)
      if (!window.__shippingInterval){
        window.__shippingInterval = setInterval(function(){
          document.querySelectorAll('[data-shipping-returns]').forEach(function(root){
            try { updateAll(root); } catch (e) {}
          });
        }, 30 * 1000);
      }

      // Update the Japan clock once per minute, aligned to the top of the minute.
      if (!window.__japanTimeAligned){
        window.__japanTimeAligned = true;
        var now = new Date();
        var msToNextMinute = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();
        setTimeout(function(){
          tickJapanTime();
          setInterval(tickJapanTime, 60 * 1000);
        }, msToNextMinute);
      }
    }

    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-init when the theme editor re-renders the block
    document.addEventListener('shopify:block:load', init);
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shipping-sweets"] && !Shopify.designMode) return;
  try {
    (function(){
    'use strict';

    var SHIP_TIMEZONE   = 'Asia/Tokyo';
    var SHIP_UTC_OFFSET = 9;

    var REGION_TIMEZONES = {
      europe:    'Europe/London',
      usa:       'America/New_York',
      australia: 'Australia/Sydney',
      asia:      'Asia/Singapore',
      uae:       'Asia/Dubai'
    };

    function parseHolidays(raw){
      if (!raw) return [];
      return raw.split(',')
        .map(function(s){ return s.trim(); })
        .filter(function(s){ return /^\d{4}-\d{2}-\d{2}$/.test(s); });
    }

    function getJSTNow(){
      var f = new Intl.DateTimeFormat('en-CA', {
        timeZone: SHIP_TIMEZONE,
        year:'numeric', month:'2-digit', day:'2-digit',
        hour:'2-digit', minute:'2-digit', second:'2-digit',
        hour12:false
      });
      var o = {};
      f.formatToParts(new Date()).forEach(function(p){ o[p.type] = p.value; });
      var h = parseInt(o.hour, 10); if (h === 24) h = 0;
      return {
        date: o.year + '-' + o.month + '-' + o.day,
        year:  parseInt(o.year, 10),
        month: parseInt(o.month, 10),
        day:   parseInt(o.day, 10),
        hour: h,
        minute: parseInt(o.minute, 10),
        second: parseInt(o.second, 10)
      };
    }

    function getDayOfWeekOfISO(s){
      var p = s.split('-');
      return new Date(Date.UTC(+p[0], +p[1]-1, +p[2])).getUTCDay();
    }

    function isBusinessDay(s, holidays){
      var d = getDayOfWeekOfISO(s);
      if (d === 0 || d === 6) return false;
      if (holidays.indexOf(s) !== -1) return false;
      return true;
    }

    function addDaysToISO(s, days){
      var p = s.split('-');
      var t = new Date(Date.UTC(+p[0], +p[1]-1, +p[2]));
      t.setUTCDate(t.getUTCDate() + days);
      return t.getUTCFullYear() + '-' +
             String(t.getUTCMonth()+1).padStart(2,'0') + '-' +
             String(t.getUTCDate()).padStart(2,'0');
    }

    function dispatchMomentUTC(isoDate, cutoffHour){
      var p = isoDate.split('-');
      return new Date(Date.UTC(+p[0], +p[1]-1, +p[2], cutoffHour - SHIP_UTC_OFFSET, 0, 0));
    }

    function calculateShipDate(cutoffHour, holidays){
      var jst = getJSTNow();
      if (isBusinessDay(jst.date, holidays) && jst.hour < cutoffHour) return jst.date;
      var ds = jst.date;
      do { ds = addDaysToISO(ds, 1); } while (!isBusinessDay(ds, holidays));
      return ds;
    }

    function formatShipDate(isoDate){
      var p = isoDate.split('-');
      var dt = new Date(Date.UTC(+p[0], +p[1]-1, +p[2], 12, 0, 0));
      return new Intl.DateTimeFormat('en-US', {
        timeZone: SHIP_TIMEZONE, weekday:'long', month:'short', day:'numeric', year:'numeric'
      }).format(dt);
    }

    function formatArrival(utcMoment, tz){
      return new Intl.DateTimeFormat('en-US', {
        timeZone: tz, weekday:'long', month:'short', day:'numeric'
      }).format(utcMoment);
    }

    function formatCountdown(ms){
      if (ms < 0) ms = 0;
      var totalMin = Math.floor(ms / 60000);
      var hours = Math.floor(totalMin / 60);
      var mins  = totalMin % 60;
      if (hours > 0){
        return hours + (hours === 1 ? ' Hour ' : ' Hours ') +
               mins  + (mins  === 1 ? ' min'  : ' mins');
      }
      return mins + (mins === 1 ? ' min' : ' mins');
    }

    function formatJapanTime(jst){
      var hh = String(jst.hour).padStart(2,'0');
      var mm = String(jst.minute).padStart(2,'0');
      return jst.year + '/' + jst.month + '/' + jst.day + ' ' + hh + ':' + mm;
    }

    function updateJapanTime(root){
      var el = root.querySelector('[data-japan-time-value]');
      if (!el) return;
      el.textContent = formatJapanTime(getJSTNow());
    }

    function updateAll(root){
      var cutoffHour = parseInt(root.getAttribute('data-cutoff-hour'), 10) || 10;
      var holidays   = parseHolidays(root.getAttribute('data-holidays') || '');
      var shipDate   = calculateShipDate(cutoffHour, holidays);
      var baseUTC    = dispatchMomentUTC(shipDate, cutoffHour);
      var nowMs      = new Date().getTime();
      var cutoffMs   = baseUTC.getTime();

      var cdEl = root.querySelector('[data-shipping-countdown]');
      if (cdEl) cdEl.textContent = formatCountdown(cutoffMs - nowMs);

      var shipEl = root.querySelector('[data-ship-date]');
      if (shipEl) shipEl.textContent = formatShipDate(shipDate);

      Object.keys(REGION_TIMEZONES).forEach(function(key){
        var el = root.querySelector('[data-region="' + key + '"]');
        if (!el) return;
        var transit = parseInt(root.getAttribute('data-transit-' + key), 10);
        if (isNaN(transit)) transit = 2;
        var arrival = new Date(baseUTC.getTime() + transit * 86400000);
        el.textContent = formatArrival(arrival, REGION_TIMEZONES[key]);
      });

      updateJapanTime(root);
    }

    function setupToggle(root){
      if (root.getAttribute('data-enable-accordion') !== 'true') return;
      var btn  = root.querySelector('[data-toggle-shipping]');
      var body = root.querySelector('.shipping-returns__body');
      if (!btn || !body) return;
      btn.addEventListener('click', function(){
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (expanded){
          body.setAttribute('hidden', '');
        } else {
          body.removeAttribute('hidden');
        }
      });
    }

    function tickJapanTime(){
      document.querySelectorAll('[data-shipping-returns]').forEach(function(root){
        try { updateJapanTime(root); } catch (e) {}
      });
    }

    function init(){
      document.querySelectorAll('[data-shipping-returns]').forEach(function(root){
        if (root.__shippingInit) return;
        root.__shippingInit = true;
        setupToggle(root);
        try { updateAll(root); } catch (e) {}
      });

      // Refresh delivery numbers every 30 seconds (countdown precision)
      if (!window.__shippingInterval){
        window.__shippingInterval = setInterval(function(){
          document.querySelectorAll('[data-shipping-returns]').forEach(function(root){
            try { updateAll(root); } catch (e) {}
          });
        }, 30 * 1000);
      }

      // Update the Japan clock once per minute, aligned to the top of the minute.
      if (!window.__japanTimeAligned){
        window.__japanTimeAligned = true;
        var now = new Date();
        var msToNextMinute = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();
        setTimeout(function(){
          tickJapanTime();
          setInterval(tickJapanTime, 60 * 1000);
        }, msToNextMinute);
      }
    }

    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-init when the theme editor re-renders the block
    document.addEventListener('shopify:block:load', init);
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
